var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import FileUpload from '~/components/common/file-upload.vue';
import { CaseAssistAntiFraudSurveyCaseService } from '~/services/domain-service/case-assist-anti-fraud-survey-case.service.ts';
var AntiFraudResult = /** @class */ (function (_super) {
    __extends(AntiFraudResult, _super);
    function AntiFraudResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryModel = {
            result: '',
            type: '',
            subType: '',
            remark: '',
            recordFiledIds: '',
        };
        _this.type = []; //欺诈类型
        _this.subType = []; //二级欺诈类型
        _this.fileList = []; //文件上传
        return _this;
    }
    AntiFraudResult.prototype.refresh = function () {
        //   重置form表单xr
        var addForm = this.$refs['form'];
        addForm.resetFields();
    };
    AntiFraudResult.prototype.refreshList = function () { };
    AntiFraudResult.prototype.close = function () {
        this.refresh();
        this.clearForm();
    };
    AntiFraudResult.prototype.clearForm = function () {
        var addForm = this.$refs['form'];
        addForm.resetFields();
        var upload = this.$refs['upload_case_import'];
        upload.reset();
        this.queryModel = {
            result: '',
            type: '',
            subType: '',
            remark: '',
            recordFiledIds: '',
        };
    };
    AntiFraudResult.prototype.mounted = function () {
        var _this = this;
        this.customDataDict.map(function (v) {
            if (v.parentId == null) {
                _this.type.push(v);
            }
        });
    };
    AntiFraudResult.prototype.onCaseRowChange = function () {
        this.clearForm();
    };
    AntiFraudResult.prototype.selectSubType = function (id) {
        var _this = this;
        this.subType = [];
        this.queryModel.subType = '';
        this.customDataDict.map(function (v) {
            if (v.parentId === id) {
                _this.subType.push(v);
            }
        });
    };
    AntiFraudResult.prototype.commit = function () {
        var _this = this;
        var addForm = this.$refs['form'];
        addForm.validate(function (valid) {
            if (!valid) {
                return;
            }
            if (_this.fileList.length) {
                _this.fileList.map(function (v) {
                    _this.queryModel.recordFiledIds += v.response.id + ',';
                });
            }
            _this.subType.map(function (v) {
                if (_this.queryModel.subType === v.id) {
                    _this.categoryName = v.name;
                }
            });
            var param = {
                id: _this.caseRow.id,
                caseAssistId: _this.caseRow.id,
                categoryName: _this.categoryName,
                dataPoolId: _this.queryModel.subType || _this.queryModel.type,
                surveyResults: _this.queryModel.result,
                recordFiledIds: _this.queryModel.recordFiledIds,
                description: _this.queryModel.remark,
            };
            _this.caseAssistAntiFraudSurveyCaseService
                .setAntiFraudCaseByCaseId(param).subscribe(function (data) {
                _this.$message.success('设置成功');
                _this.close();
                _this.refreshList();
            });
        });
    };
    __decorate([
        Prop({ required: true })
    ], AntiFraudResult.prototype, "caseRow", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudSurveyCaseService)
    ], AntiFraudResult.prototype, "caseAssistAntiFraudSurveyCaseService", void 0);
    __decorate([
        State
    ], AntiFraudResult.prototype, "customDataDict", void 0);
    __decorate([
        Emit('refreshList')
    ], AntiFraudResult.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], AntiFraudResult.prototype, "close", null);
    __decorate([
        Watch('caseRow')
    ], AntiFraudResult.prototype, "onCaseRowChange", null);
    AntiFraudResult = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
            },
        })
    ], AntiFraudResult);
    return AntiFraudResult;
}(Vue));
export default AntiFraudResult;
